import { store } from '@/store'
import { employeeRoleApi } from '@/store/services'
import { toOptions } from '@/utils'
import { useEffect, useState } from 'react'
import { createSearchParams } from 'react-router-dom'
import { AsyncPaginate } from 'react-select-async-paginate'
import { SelectWrapper } from '../wrapper'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const EmployeeRoleSelector = ({ value, onChange, required = false }) => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState({})
  const loadOptions = async (search, _loadedOptions, { page }) => {
    const searchParams = createSearchParams({ page, per_page: 10 })

    if (search) searchParams.set('q', search)

    const { employeeRoles, meta } = await store.dispatch(
      employeeRoleApi.endpoints.getEmployeeRoles.initiate(`?${searchParams.toString()}`)
    ).unwrap()

    const options = toOptions({ data: employeeRoles })
    const hasMore = page < meta.pagination.total_pages

    return {
      options,
      hasMore,
      additional: {
        page: page + 1
      }
    }
  }

  const getCurrentEmployeeRole = async (id) => {
    const { employeeRole = {} } = await store.dispatch(
      employeeRoleApi.endpoints.getEmployeeRole.initiate(id)
    ).unwrap()

    setSelectedOption(
      toOptions({ data: [employeeRole] })[0]
    )
  }

  // Si el selector esta en un popover o modal, se pierde el selectedOption
  // Esta es una forma para rescatarlo si es que se pierde el estado.
  useEffect(() => {
    if (!value) {
      setSelectedOption({})
      return
    }
    if (value === selectedOption.value) return

    getCurrentEmployeeRole(value)
  }, [value])

  const handleChange = (option) => {
    setSelectedOption(option)
    onChange(option)
  }

  return (
    <SelectWrapper label={t('role.one')} required={required}>
      {(styles) => (
        <AsyncPaginate
          value={Object.keys(selectedOption).length ? selectedOption : null}
          debounceTimeout={600}
          placeholder={t('select.one')}
          onChange={handleChange}
          loadOptions={loadOptions}
          styles={styles}
          menuPortalTarget={document.body}
          loadingMessage={() => t('select.loading')}
          additional={{
            page: 1
          }}
        />
      )
      }
    </SelectWrapper>
  )
}

EmployeeRoleSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number
}
